const specialismsContainer = document.querySelector('.specialisms-sec__container');
if (specialismsContainer && !specialismsContainer.dataset.specialismsInit) {
  specialismsContainer.dataset.specialismsInit = 'true';

  const specialismsItemsArr = specialismsContainer.querySelectorAll('.specialisms-sec__item');
  let activeIndex = -1;
  let activeStateClass = '';
  let autoplayInterval;
  const intervalValue = 6000;
  let started = false;

  function setItemsActiveStateClass(index) {
    if (activeStateClass) {
      specialismsItemsArr.forEach((item) => item.classList.remove(activeStateClass));
    }

    activeStateClass = `active-${index + 1}`;
    specialismsItemsArr.forEach((item) => item.classList.add(activeStateClass));
  }

  function openItem(item, index) {
    item.classList.add('active');
    setItemsActiveStateClass(index);
  }

  function closeItems() {
    specialismsItemsArr.forEach((item) => item.classList.remove('active'));
  }

  function startAutoplay() {
    clearInterval(autoplayInterval);

    autoplayInterval = setInterval(() => {
      closeItems();
      activeIndex++;
      if (activeIndex >= specialismsItemsArr.length) {
        activeIndex = 0;
      }
      openItem(specialismsItemsArr[activeIndex], activeIndex);
    }, intervalValue);
  }

  function pauseAutoplay() {
    clearInterval(autoplayInterval);
  }

  function resumeAutoplay() {
    startAutoplay();
  }

  specialismsItemsArr.forEach((item, i) => {
    item.addEventListener('click', () => {
      pauseAutoplay();
      closeItems();
      activeIndex = i;
      openItem(item, i);
      startAutoplay();
    });
  });

  specialismsContainer.addEventListener('mouseenter', pauseAutoplay);
  specialismsContainer.addEventListener('mouseleave', resumeAutoplay);
  specialismsContainer.addEventListener('click', () => {
    pauseAutoplay()
    setTimeout(() => {
      resumeAutoplay()
    }, 500)
  })

  const observerOptions = {
    root: null,
    rootMargin: '0px',
    threshold: 0.85,
  };

  const observer = new IntersectionObserver((entries) => {
    entries.forEach((entry) => {
      if (!started) {
        if (entry.isIntersecting) {
          setTimeout(() => {
            activeIndex = 0;
            openItem(specialismsItemsArr[0], 0);
            startAutoplay();
            started = true;
          }, 300);
        } else {
          pauseAutoplay();
        }
      }
    });
  }, observerOptions);

  observer.observe(specialismsContainer);
}
